import { ThumbnailCard } from './ThumbnailCard'
import type { Entry } from '../lib/types'

interface ThumbnailGridProps {
  items: Array<Entry & { path: string }>
  onItemClick: (item: Entry & { path: string }) => void
}

export function ThumbnailGrid({ items, onItemClick }: ThumbnailGridProps) {
  if (!items || items.length === 0) {
    return (
      <div className="empty-state">
        <p>No items to display</p>
      </div>
    )
  }
  
  return (
    <div className="thumbnail-grid">
      {items.map(item => (
        <ThumbnailCard
          key={item.path}
          entry={item}
          path={item.path}
          onClick={() => onItemClick(item)}
        />
      ))}
    </div>
  )
}